/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { QuantityUsageType } from './QuantityUsageType';
import {
    QuantityUsageTypeFromJSON,
    QuantityUsageTypeFromJSONTyped,
    QuantityUsageTypeToJSON,
} from './QuantityUsageType';
import type { CreateEvaluationQuantityUsageDto } from './CreateEvaluationQuantityUsageDto';
import {
    CreateEvaluationQuantityUsageDtoFromJSON,
    CreateEvaluationQuantityUsageDtoFromJSONTyped,
    CreateEvaluationQuantityUsageDtoToJSON,
} from './CreateEvaluationQuantityUsageDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { CreateSetupQuantityUsageDto } from './CreateSetupQuantityUsageDto';
import {
    CreateSetupQuantityUsageDtoFromJSON,
    CreateSetupQuantityUsageDtoFromJSONTyped,
    CreateSetupQuantityUsageDtoToJSON,
} from './CreateSetupQuantityUsageDto';

/**
 * 
 * @export
 * @interface CreateUpdateNumericQuantityDto
 */
export interface CreateUpdateNumericQuantityDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateNumericQuantityDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateNumericQuantityDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateNumericQuantityDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {StateOfUse}
     * @memberof CreateUpdateNumericQuantityDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {QuantityUsageType}
     * @memberof CreateUpdateNumericQuantityDto
     */
    quantityUsageType?: QuantityUsageType;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateUpdateNumericQuantityDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {CreateSetupQuantityUsageDto}
     * @memberof CreateUpdateNumericQuantityDto
     */
    setupUsage?: CreateSetupQuantityUsageDto;
    /**
     * 
     * @type {CreateEvaluationQuantityUsageDto}
     * @memberof CreateUpdateNumericQuantityDto
     */
    evaluationUsage?: CreateEvaluationQuantityUsageDto;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateNumericQuantityDto
     */
    $type?: CreateUpdateNumericQuantityDtoTypeEnum;
}


/**
 * @export
 */
export const CreateUpdateNumericQuantityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateUpdateNumericQuantityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateUpdateNumericQuantityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateUpdateNumericQuantityDtoTypeEnum = typeof CreateUpdateNumericQuantityDtoTypeEnum[keyof typeof CreateUpdateNumericQuantityDtoTypeEnum];



/**
 * Check if a given object implements the CreateUpdateNumericQuantityDto interface.
 */
export function instanceOfCreateUpdateNumericQuantityDto(value?: unknown): value is CreateUpdateNumericQuantityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateUpdateNumericQuantityDtoTypeEnum)[0];
}

export function CreateUpdateNumericQuantityDtoFromJSON(json: any): CreateUpdateNumericQuantityDto {
    return CreateUpdateNumericQuantityDtoFromJSONTyped(json, false);
}

export function CreateUpdateNumericQuantityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateNumericQuantityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'state': json['state'] == null ? undefined : StateOfUseFromJSON(json['state']),
        'quantityUsageType': json['quantityUsageType'] == null ? undefined : QuantityUsageTypeFromJSON(json['quantityUsageType']),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'setupUsage': json['setupUsage'] == null ? undefined : CreateSetupQuantityUsageDtoFromJSON(json['setupUsage']),
        'evaluationUsage': json['evaluationUsage'] == null ? undefined : CreateEvaluationQuantityUsageDtoFromJSON(json['evaluationUsage']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateUpdateNumericQuantityDtoToJSON(value?: CreateUpdateNumericQuantityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'isAvailable': value['isAvailable'],
        'state': StateOfUseToJSON(value['state']),
        'quantityUsageType': QuantityUsageTypeToJSON(value['quantityUsageType']),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'setupUsage': CreateSetupQuantityUsageDtoToJSON(value['setupUsage']),
        'evaluationUsage': CreateEvaluationQuantityUsageDtoToJSON(value['evaluationUsage']),
        '$type': value['$type'],
    });
}

